import React from 'react'
import _ from 'lodash'
import $ from 'jquery'
import Icon from 'react-fa'
import Immutable from 'immutable'
import {Panel, Button,} from 'react-bootstrap'
import {request} from '../helpers/request'
import {makeGrids} from '../helpers/makeGrids.js'
import {redirectIfNotLoggedIn} from '../helpers/access'
import {t} from '../helpers/translate'
import LoadingComponent from './common/LoadingComponent'
import FieldComponent from './common/FieldComponent'
import ModalComponent from './common/ModalComponent'
const config = require('config');

class ContactUs extends React.Component {

  constructor(props) {
    redirectIfNotLoggedIn();
    super(props);

    this.state = {
      submissionSuccessful: false,
      loading: false,
      errors: [],

      showModal: false,
      modalTitle: null,
      modalBody: null,

      data: Immutable.Map({}),
      parsedForm: null,

      requestData: null,
      userLoaded: false,
      configLoaded: false,
    }
  }

  loadUserData(responseData, statusCode) {
    if (statusCode == 200) {
      let userData = Immutable.fromJS(responseData);
      this.setState({
        userLoaded: true,
        data: userData,
      })
    } else {
      this.showModal(t('Error'), t('Unable to get user data'));
    }
  }

  loadData() {
    const userId = sessionStorage.getItem('user_id');
    $.when(
      request(`${config.default.auth_base_api}/member/${userId}`, 'GET', null, this.loadUserData.bind(this)),
    ).done(this.parseForm.bind(this));
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.location.reload();
    }
  }

  parseForm() {
    this.setState({
      parsedForm:
        config.default.contact_us[sessionStorage.getItem('org')].field_groups.reduce(
          (previousGroups, currentGroup) => {
            if (currentGroup.repeat) {
              for (let i = currentGroup.repeat.start; i < this.repeatCount(currentGroup); i++) {
                previousGroups.push(ContactUs.parseRepeatable(currentGroup, i));
              }
            } else {
              previousGroups.push(currentGroup);
            }
            return previousGroups;
          }, []
        ),
      configLoaded: true
    });
  }

  static parseRepeatable(group, index) {
    return JSON.parse(
      JSON.stringify(group)
      .replace(/\*\+\+/g, String(index + 1))
      .replace(/\*/g, String(index))
    );
  }

  isFormSubmitted() {
    return this.state.submissionSuccessful;
  }

  handleDataChange(delta) {
    this.setState({
      data: this.state.data.setIn(delta.key_path, delta.value.trim()),
    })
  }

  handleModalClose() {
    this.setState({showModal: false})
  }

  getRequestData() {
    const rawData = this.state.data;
    return rawData != undefined ? rawData.toJS() : null;
  }

  scrollToTheTop() {
    $('html, body').animate({scrollTop: 0}, 'fast');
  }

  setStateError(msg) {
    this.state.errors.push(msg);
    this.setState({errors: this.state.errors});
  }

  validateField(field, fieldName) {
    if(field == null || field == '' ) {
      this.setStateError(`${t('Please enter a')} ${t(fieldName)}`);
    }
  }
  
  validateEnquiry(enquiry_type) {
    if(enquiry_type == null) {
      this.setStateError(`${t('Please select a')} ${t('Type of Inquiry')}`);
    }
  }

  validateEmail(email) {
    const format = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!format.test(email)) {
      this.setStateError(`${t('Please enter a valid')} ${t('Email')}`);
    }
  }

  validateReqData = (requestData) => {
    if(requestData == null) {
      this.setStateError(t('Please complete all required fields'));
    } else {
      this.validateField(requestData.first_name, t('First Name'));
      this.validateField(requestData.last_name, t('Last Name'));
      this.validateEmail(requestData.email);
      this.validateEnquiry(requestData.enquiry_type);
      this.validateField(requestData.body, t('Message'));
    }

    return this.state.errors.length == 0;
  }

  postRequestData() {
    const reqType = 'POST';
    const requestData = this.getRequestData();

    if(this.validateReqData(requestData)) {
      this.setState({requestData: requestData, loading: true},
        () => {
          request(`${config.default.api}/contactus`, reqType, requestData, (data, statusCode) => {
            this.setState({loading: false})
            if (statusCode == '200') {
              this.setState({
                  responseData: data,
                  submissionSuccessful: true
                }
              );
            } else {
               this.setState({errors: [`${t('Unable to submit the request')} (Code ${statusCode} : ${data}).`]})
               this.scrollToTheTop();
            }
          })
        }
      );
    }
    this.scrollToTheTop();
  }

  cleanErrors() {
    this.state.errors = [];
  }

  repeatCount(group) {
    return this.state.data.getIn(group.repeat.key_path).count();
  }

  showModal(title, body) {
    this.setState({
        showModal: true,
        modalBody: body,
        modalTitle: title
      }
    )
  }

  renderSubmitButton() {
    return <Button className="btn-submit button-secondary primary-btn-color"
      onClick={this.submitForm.bind(this)}>
      <Icon name="share-square"/>{` ${t('Submit')}`}
    </Button>
  }

  isStatic(field) {
    return field.is_static_by_default;
  }

  fieldHasTextarea(field) {
    return field.format && field.format === 'textarea';
  }

  fill(fields) {
    let hasTextArea = false
    const elems = fields.map((field) => {
      hasTextArea = this.fieldHasTextarea(field)
          return <div>
            <label className='text-uppercase'>{t(field.as)}</label>
            <div>
              <FieldComponent
                ref={field.key_path}
                onDataChanged={this.handleDataChange.bind(this)}
                type={field.type}
                format={field.format}
                keyPath={field.key_path}
                keyPathAliases={field.key_path_aliases}
                options={field.options}
                isStatic={this.isStatic(field)}
                args={field.args}
                data={this.state.data}
              />
            </div>
          </div>
        }
    );
    const cols = hasTextArea ? 1 : 2;
    return makeGrids(cols, elems.filter((elem) => {
        return elem
    }));
  }

  submitForm() {
    this.cleanErrors();
    this.postRequestData();
  }

  showConfirmation() {
    return (
      <div className="submit-content">
        <h2 className="form-submit"><strong>{t('Thank you for your message.')}</strong></h2>
        <h4>{t('Your request is currently being processed. We’ll get back to you within one business day.')}</h4>
      </div>
    )
  }
 
  showContactInfo() {
    return(
        <div className='container-contact contact-form'>
          <div className= "contact-info">
              <h3 className='body-title'>{t('Partner Services')}</h3>
              <p>{t('You can call us at')} <strong>{t('416-644-3662')}</strong> ({t('or toll-free at')} <strong>1-800-292-9460</strong> {t('to speak with a partner services representative.')})</p>
              <p><strong>{t('Email')}:</strong> {t('msh.agent@americas.msh-intl.com')}</p>
              <p><strong>{t('Fax')}:</strong> {t('416-730-1878 (or toll-free at 1-877-844-6453)')}</p>
              <p><strong>{t('By mail')}:</strong> {t('150 King St West, Suite 602, P.O. Box 75, Toronto, ON, M5H 1J9, Canada')}</p>
              <p><strong>{t('Hours of operation')}:</strong><br/>{t('Monday to Friday – 9 AM to 5 PM EST')}<br/>({t('We are open most holidays, 9 AM to 5 PM')})</p>
          </div>
          <div className= "contact-info">
              <h3 className='body-title'>{t('Contact Centre')}</h3>
              <p>{t('If you must reach someone outside these hours, you can also call us at')} <strong>{t('416-730-8488')}</strong> ({t('or toll-free at')} <strong>{t('1-800-360-3234')}</strong> {t('to speak with a customer service representative.')})</p>
              <p><strong>{t('Hours of operation')}:</strong><br/>{t('Monday to Friday – 8 AM to 6 PM EST')}<br/>({t('We are open most holidays, 9 AM to 5 PM')})</p>
          </div>
        </div>
      )
    }

  getPageTitle() {
    return t('Contact Us');
  }

  showHelpMessage() {
    return <div className='text-center page-subtitle'>{t('Whether you have questions about a product or about your account, we\'re here to help.')} </div>
  }

  displayErrors() {
    const errors = this.state.errors;

    if(errors && errors.length > 0) {
      return (
        <div className='alert alert-danger' role='alert'>
          <div className='error-list'>
            {errors.map((error, index) => <li key={index}>{error}</li>)}
          </div>
        </div>
      );
    }
    return undefined;
  }

  render() {
     if(this.state.userLoaded && this.state.configLoaded) {
        return this.isFormSubmitted() ? this.showConfirmation() :
         <div className='container'>
            <h2 className="text-center page-title">{this.getPageTitle()}</h2>
            {this.showHelpMessage()}
              <div className='contact-form'>
                <div className="row">
                  <div className="col-md-12">
                    {this.displayErrors()}
                  </div>
                </div>
                <div className="search-box form-btn">
                  {
                    this.state.parsedForm.map(
                      (group, i) => {
                        let groupElem =
                          <div className='row' key={i}>
                            <div className='col-md-10 form-content'>
                              {group.fields && this.fill(group.fields)}
                            </div>
                          </div>
                        return groupElem;
                      }
                    )
                  }
                  <div className="center-children">
                    {this.renderSubmitButton()}
                  </div>
                </div>
              </div>
            <LoadingComponent show={this.state.loading} text={t('Sending')} />
            { this.showContactInfo() }
            <ModalComponent
              title={this.state.modalTitle}
              body={this.state.modalBody}
              onClose={this.handleModalClose.bind(this)}
              show={this.state.showModal}
            />
         </div>
     }
    else{
      return <LoadingComponent show={this.state.loading} text={t('Loading')} />
    }
  }
}
ContactUs.displayName = t('Contact Us');
export default ContactUs;


// WEBPACK FOOTER //
// ./src/components/ContactUs.js